import * as React from "react"
import { ThemeProvider as CustomThemeProvider, useTheme } from "@/lib/theme"

interface ThemeProviderProps {
  children: React.ReactNode;
  defaultTheme?: 'light' | 'dark' | 'coral' | 'system';
  storageKey?: string;
  themes?: string[];
  attribute?: string;
  enableSystem?: boolean;
  disableTransitionOnChange?: boolean;
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <CustomThemeProvider {...props}>{children}</CustomThemeProvider>
}

export { useTheme }